var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from "@mui/material";
import { getLocalizedString } from "@nitra/nkmb-card-components/utils";
import { NkmbIconFoto } from "@nitra/nkmb-theme";
import { useTranslation } from "react-i18next";
export function ImageWithSubtitleAndCredits(props) {
    var subtitle = props.subtitle, credits = props.credits;
    var i18n = useTranslation().i18n;
    var currentLang = i18n.language;
    return (_jsx(Box, __assign({ sx: { width: "100%", pb: 1 } }, { children: _jsxs(Box, __assign({ sx: { width: "100%", height: "100%" } }, { children: [_jsx("img", { src: props.url, alt: subtitle && getLocalizedString(subtitle, currentLang), style: { width: "100%", height: "100%" } }), (props.subtitle || props.credits) &&
                    _jsxs(Stack, __assign({ direction: "row", alignItems: "center" }, { children: [_jsx(Typography, __assign({ sx: { mr: "auto" }, variant: "podSliko" }, { children: subtitle && getLocalizedString(subtitle, currentLang) })), credits && _jsxs(_Fragment, { children: [_jsx(NkmbIconFoto, {}), _jsx(Typography, __assign({ sx: { pl: 1 }, variant: "podSliko" }, { children: credits }))] })] }))] })) })));
}
